/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import { Link } from 'react-router-dom';
// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  Container,
  Media,
} from 'reactstrap';
import utils from '../../utils.js';

class AdminNavbar extends React.Component {
  renderUser() {
    let avatar = null;
    let username = 'Not logged in';
    if (this.props.user) {
      const { email, discordId, discordTag, discordAvatar } = this.props.user;
      let avatarUrl;
      if (!discordAvatar) {
        avatarUrl = `${process.env.PUBLIC_URL}/images/default-discord-avatar.png`;
      } else {
        avatarUrl = `https://cdn.discordapp.com/avatars/${discordId}/${discordAvatar}`;
      }

      avatar = (
        <span className="avatar avatar-sm rounded-circle">
          <img alt="..." src={avatarUrl} />
        </span>
      );

      username = discordTag;
    }
    return (
      <Media className="align-items-center">
        {avatar}
        <Media className="ml-2 d-none d-lg-block">
          <span className="mb-0 text-sm font-weight-bold">{username}</span>
        </Media>
      </Media>
    );
  }

  logout() {
    window.location.href = `${utils.getEndpoint()}/auth/logout`;
  }

  goHome() {
    window.location.href = `/`;
  }

  render() {
    return (
      <>
        <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
          <Container fluid>
            <Link
              className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block"
              to="/"
            >
              {this.props.brandText}
            </Link>
            <Nav className="align-items-center d-none d-md-flex" navbar>
              <UncontrolledDropdown nav>
                <DropdownToggle className="pr-0" nav>
                  {this.renderUser()}
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-arrow" right>
                  <DropdownItem
                    style={{ cursor: 'pointer' }}
                    onClick={() => this.goHome()}
                  >
                    <i className="ni ni-building" /> Home
                  </DropdownItem>
                  <DropdownItem divider className="m-0" />
                  <DropdownItem
                    style={{ cursor: 'pointer' }}
                    onClick={() => this.logout()}
                  >
                    <i className="ni ni-user-run" /> Logout
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Container>
        </Navbar>
      </>
    );
  }
}

export default AdminNavbar;
